import React from 'react'
import { M_Table } from 'src/components/M_Components'

export const Carrier = ({ roles }) => {

    return (
        <M_Table entityName={'Carrier'} filtersOnTable rolePermissions={roles} />
    )
}